import {arrayElementByKeyValue} from "./arrayHelper";

export class CountryListLoader {

    private static countryList = null;
    private static stateList = null;
    private static suggestedCountry = "";

    private static loaded = false;

    private static callbacksAfterLoad:(()=>void)[] = [];

    public static getCountryList = ()=>CountryListLoader.get("countryList");
    public static getStateList = ()=>CountryListLoader.get("stateList");

    private static get(property) {
        if(!CountryListLoader.loaded) {
            console.error("countrylist queried ("+property+")before it was loaded");
        }
        return CountryListLoader[property];
    }

    public static setCountryList(countryListResponse, successCallback:(data)=>void, resourceManager) {
        CountryListLoader.loaded = true;
        CountryListLoader.executeCallbacks();
        CountryListLoader.countryList = countryListResponse.countryList;
        CountryListLoader.stateList = countryListResponse.stateList;
        CountryListLoader.suggestedCountry = countryListResponse.suggestedCountry;
        successCallback(countryListResponse)
        if(typeof(resourceManager) !== "undefined") {
            resourceManager.registerLoadedResourceWithoutData("countryList")
        }
    }

    public static executeAfterLoad(func) {
        if(CountryListLoader.loaded) {
            func();
        } else {
            CountryListLoader.callbacksAfterLoad.push(func);
        }
    }

    private static executeCallbacks() {
        while(CountryListLoader.callbacksAfterLoad.length>0) {
            const func = CountryListLoader.callbacksAfterLoad.pop() as ()=>void;
            func();
        }
    }

    public static getlocalizedState(landIso, stateIso) {
        const stateList = CountryListLoader.getStateList();
        if(stateList === null) {
            return stateIso;
        }
        if(typeof(stateList[landIso.toUpperCase()]) !== "undefined") {
            const entry = arrayElementByKeyValue(stateList[landIso.toUpperCase()], "kuerzel", stateIso);
            if(entry !== null) {
                return entry.state;
            }
        }
        return stateIso
    }

    public static getlocalizedLand(landIso) {
        const countryList = CountryListLoader.getCountryList();
        if(countryList === null) {
            return landIso;
        }
        const entry = arrayElementByKeyValue(countryList, "iso3166", landIso.toUpperCase());
        if(entry !== null) {
            return entry.landIntName;
        }
        return landIso;
    }
}
